



































































import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import NavBarMenu from "./NavBarMenu.vue";
import UserAvatar from "./UserAvatar.vue";
import { UserModule } from "../store/modules/user";
import { AppModule } from "../store/modules/app";

@Component({
  name: "NavBar",

  components: {
    UserAvatar,
    NavBarMenu,
  },
})
export default class NavBar extends Vue {
  isMenuNavBarActive = false;

  get menuNavBarToggleIcon() {
    return this.isMenuNavBarActive ? "close" : "dots-vertical";
  }

  get menuToggleMobileIcon() {
    return this.isAsideMobileExpanded ? "backburger" : "forwardburger";
  }

  get menuToggleIcon() {
    return this.isAsideExpanded ? "backburger" : "forwardburger";
  }

  get toggleTooltip() {
    return this.isAsideExpanded ? "Collapse" : "Expand";
  }

  get isNavBarVisible() {
    return AppModule.isNavBarVisible;
  }

  get isAsideExpanded() {
    return AppModule.isAsideExpanded;
  }

  get isAsideMobileExpanded() {
    return AppModule.isAsideMobileExpanded;
  }

  get isAsideRightVisible() {
    return AppModule.isAsideRightVisible;
  }

  get userName() {
    return UserModule.user ? UserModule.user.username : "";
  }

  get hasUpdates() {
    return AppModule.hasUpdates;
  }

  get user() {
    return UserModule.user;
  }

  get avatarImageUrl() {
    let user = UserModule.user;
    if (!user) return "";
    let avatarId = user.username;
    if (user.firstName && user.lastName) {
      avatarId = `${user.firstName} ${user.lastName}`;
    } else if (user.firstName || user.lastName) {
      avatarId = user.firstName || user.lastName;
    }

    return `https://avatars.dicebear.com/v2/initials/${avatarId}.svg`;
  }

  menuToggle() {
    AppModule.ToggleSideBar();
  }

  menuToggleMobile() {
    AppModule.ToggleMobileSideBar();
  }

  menuNavBarToggle() {
    this.isMenuNavBarActive = !this.isMenuNavBarActive;
  }

  updatesToggle() {
    AppModule.ToggleRightSideBar();
  }

  async logout() {
    await UserModule.LogOut();
    this.$router.push({ name: "login" });
  }
}
